export const AI_BOT_ID = '00000000-0000-0000-0000-000000000001';
export const AI_BOT_NAME = 'مساعد لوجي الذكي';
